import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = {
    onConnect: { type: Boolean, default: false }
  }

  connect() {
    if (this.onConnectValue) {
      this.submitForm()
    }
  }

  initialize() {
    this.submit = this.debounce(this.submit.bind(this), 200)
  }

  submit() {
    $(this.formTarget).trigger('submit.rails')
  }

  submit_wait() {
    setTimeout(() => {
      $(this.formTarget).trigger('submit.rails')
    }, 500)
  }

  clear_and_submit () {
    const input = this.formTarget.querySelector('input[name="q[name_cont]"]')
    input.value = ''
    $(this.formTarget).trigger('submit.rails')
  }  

  submitForm() {
    const form = this.hasFormTarget ? this.formTarget : this.element

    if (form.dataset.remote === 'true') {
      $(form).trigger('submit.rails')
    } else if (form.requestSubmit) {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }

  debounce(func, wait) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }
}